module.exports = __webpack_public_path__ + "static/media/event-security.0f31b0a9.png";